module.exports = __webpack_public_path__ + "media/Social/Email-b8f3eaf5.svg";